import { render, staticRenderFns } from "./responsiblePersonsAddView.vue?vue&type=template&id=014143ef&scoped=true&"
import script from "./responsiblePersonsAddView.vue?vue&type=script&lang=js&"
export * from "./responsiblePersonsAddView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014143ef",
  null
  
)

export default component.exports